import { CompanyList } from '@/app/types/constantDataType'
import { Contact, EmailCheckboxState } from '@/app/types/singleMemberType'
import { SubscriptionType } from '@/app/types/subscriptionType'

export const formatCompanyString = (items: CompanyList[]) => {
  return (
    items?.map((item: any) => {
      const cityName = item?.city?.name ? `, ${item.city.name}` : ''
      const countryName = item?.country ? `, ${item.country}` : ''
      return `${item.name}${cityName}${countryName}`
    }) ?? []
  )
}

export const formatCompanySingleString = (item: CompanyList) => {
  const cityName = item?.city?.name ? `, ${item.city.name}` : ''
  const countryName = item?.country ? `, ${item.country}` : ''
  return `${item.name}${cityName}${countryName}`
}

const keyMapping: Record<string, string> = {
  BuyerAlertSubscription: 'buyer_alert_subscription',
  FructidorBusinessSubscription: 'fructidor_business_subscription',
  FructidorServicesSubscription: 'fructidor_services_subscription',
  NewsletterSubscription: 'newsletter_subscription',
  PartnerBusinessSubscription: 'partner_business_subscription',
}

export const convertEmailSubscriptions = (
  oldFormat: Record<string, string[]>
): EmailCheckboxState => {
  const newFormat: EmailCheckboxState = {}

  for (const [oldKey, value] of Object.entries(oldFormat)) {
    const newKey = keyMapping[oldKey]
    if (newKey) {
      newFormat[newKey] = value
    }
  }

  return newFormat
}

export const getFormattedPrice = (
  planTitle: string,
  subScriptionList: SubscriptionType[]
) => {
  const foundPlan = subScriptionList?.find((sub) => sub?.name === planTitle)
  return foundPlan?.price ? `€ ${Number(foundPlan.price).toString()}` : ''
}

export const formatMemberData = (contact: Contact) => {
  return {
    emails: contact?.contact_methods?.filter(
      (item: any) => item.contact_type == 'email'
    ),
    phones: contact?.contact_methods?.filter(
      (item: any) => item.contact_type == 'phone'
    ),
    mobiles: contact?.contact_methods?.filter(
      (item: any) => item.contact_type == 'mobile'
    ),
  }
}

export const convertNaNToOne = (value: any) => {
  const page = Number(value || 1)
  const finalPage = isNaN(page) ? 1 : page
  return finalPage
}
